<template>
	<div>
		<div class="mt-3 mb-2">
			<router-link
				v-for="tab in tabs"
				:key="tab.href"
				:to="{ name: tab.href }"
				class="btn mr-2 mb-2"
				:class="$route.name === tab.href ? 'btn-primary' : 'btn-outline-primary'"
				replace
			>{{ $t(tab.label) }}</router-link>
		</div>

		<router-view
			:horse_id="horse_id"
		></router-view>
	</div>
</template>

<script>
export default {
	name: 'Stallion',
	props: ['horse_id'],
	data() {
		return {
			tabs: [
				{ label: 'monte.semence.stocks', href: 'StallionStocks' },
				{ label: 'monte.semence.commandes', href: 'StallionCommandes' },
				{ label: 'monte.semence.expeditions', href: 'StallionExpeditions' }
			]
		}
	}
}
</script>
